import React from 'react'

import { Marker } from "!react-map-gl"

export const MarkerImage = ({
    className,
    feature = {},
    latitude = null,
    longitude = null,
    offsetLeft,
    offsetTop,
    children,
    image = null,
    imageSrc = null,
    imageSize = 60,
    onClick,
    onMouseEnter,
    onMouseOver = () => {
        console.log('DEBUG MARKER: onMouseOver');
    },
    onMouseOut = () => {
        console.log('DEBUG MARKER: onMouseOut');
    },
    onMouseLeave,
    onTouchStart,
    showArrow = false,
    showImage = true,
    showPulse = false,
    slug = 'marker',
    ...props
}) => {

  if (!latitude || !longitude) {
    return null
  }

  const arrowStyle = {
    position: `absolute`,
    bottom: `-20px`,
    width: 0,
    height: 0,
    border: `top: 20px solid #FFFFFF`,
    border: `right: 20px solid transparent`,
    border: `bottom: 0px solid transparent`,
    borderLeft: `20px solid transparent`
  }

  const markerStyle = {
    maxHeight: 60,
    maxWidth: 60,
  }

  const MarkerLink = (
    <a
      onClick={((e) => onClick(e, feature))}
      onMouseOver={((e) => onMouseOver(e, feature))}
      onMouseOut={((e) => onMouseOut(e, feature))}
      className={`marker ${showImage ? 'photo' : 'icon'}`}
      style={markerStyle}>
      {image
        ? image
        : null
      }

      {imageSrc
        ? <img
          loading='lazy'
          draggable={false}
          src={imageSrc}
          style={{ minHeight: imageSize, minWidth: imageSize }} />
        : null
      }

      {showArrow
        ? <div className='arrow' style={arrowStyle} />
        : null
      }
    </a>
  )

  return (
    <Marker
      key={slug}
      anchor='bottom'
      longitude={longitude}
      latitude={latitude} >

      {MarkerLink}

      {showPulse
        ? <Pulse show={showPulse} />
        : null
      }
    </Marker>
  )
}

export default MarkerImage;